function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabResultsNavIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "23px",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#97A5A9",
      fillOpacity: 1
    },
    d: "M 11.316406 22.039062 C 13.257812 22.039062 15.117188 21.253906 16.488281 19.851562 C 17.863281 18.449219 18.632812 16.546875 18.632812 14.5625 C 18.632812 10.429688 11.316406 0.957031 11.316406 0.957031 C 11.316406 0.957031 4.003906 10.429688 4.003906 14.5625 C 4.003906 16.546875 4.773438 18.449219 6.148438 19.851562 C 7.519531 21.253906 9.378906 22.039062 11.316406 22.039062 Z M 11.316406 22.039062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabResultsNavIcon);
export default __webpack_public_path__ + "static/media/LabResults_Nav_Icon.2cb9370805329899e8f6ac26337a6483.svg";
export { ForwardRef as ReactComponent };